export default __webpack_public_path__ + "static/media/1@2x.4934a949.png";